export const shifterPipelineState = {
  readyForQa: "readyForQa",
  raisingErrors: "raisingErrors",
  submitted: "submitted",
  invalid: "invalid",
  valid: "valid",
  complete: "complete",
};
